/* eslint-disable react/jsx-key */

import React from 'react';
import { useTable } from 'react-table';
import { formatNumber } from 'scripts/components/Utils/numbers';

const BasicDataTable = ({ columns, data, className, currency, locale }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable({
            columns,
            data,
        });

    const cellsLength = columns.length;

    return (
        <table
            {...getTableProps()}
            className={`${className} table-cols-${cellsLength}`}
        >
            <thead>
                {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                            <th {...column.getHeaderProps()}>
                                {column.render('Header')}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                                return (
                                    <td {...cell.getCellProps()}>
                                        <p>{cell.column.id === "OrderValue" ? formatNumber(cell.value, currency, locale) : cell.render('Cell')}</p>
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default BasicDataTable;